// var icrm_modal_form = "#icrm-modal-form";
// var icrm_page_form = "#icrm-page-form";
// var modal_info_title = "#modal-info-title";
// var modal_info_content = "#modal-info-content";
// var modal_info_footer = "#modal-info-footer";
// var icrm_info_modal = "#icrm-info-modal";
// var icrm_liqpay_form = "#icrm-liqpay-form";

// TODO: rename icube_args to formsZoneArgs, formszone_args, formscube_args, etc

(function(){

    'use strict';

    var $           = require('./parts/jCube');
    var Const        = require('./defines');
    var App          = require('./parts/App');
    var ErrorHandler = require('./parts/exceptions');

    require('./parts/ui');

    if(typeof icube_args == 'undefined'){
        console.error('Arguments for icForms is empty.');
        throw new Error('[100-00] Empty arguments');
    }

    App.init(icube_args);

    window.onload = function() {

        try {

            var q = $.parseUriArguments();
            if (typeof q.action != 'undefined' && q.action in App.actions) {
                App.actions[q.action](App, q);
            }

            $(Const.icform_static).buildForms(App);

        } catch (e) {
            App.logError(e, false);
        }

    };

    /*
     * Клік-вибір методу оплати
     */
    $( document ).on('click', '.onclick-pay-method', function(){
        var action = $(this).data('action');
        var arg = JSON.parse($.base64Decode(action));

        if(!('payType' in arg) || !('paySlug' in arg) || !('actionUrl' in arg)){
            throw new Error('[101-03] Payment Data Error.');
        }

        arg.sessionId = App.getSessionId();

        App.sendApi({
            url: App.getApiUrl() + '/' + $.trim(arg.actionUrl, '/'),
            data: { action: $.base64Encode(JSON.stringify(arg)) },
            type: "POST"
        });
    });

    /*
     * Клік по кнопці «Реєстрація»
     */
    $(document).on('click', Const.selector_for_open_form, function (e) {

        e.preventDefault();

        var token = $(this).data('icform-id');

        if( !token ) {
            throw new ErrorHandler.CubeError('[001.10] Empty token.');
        }

        $(this).prop("disabled", true);

        App.sendApi({
            url: App.getApiUrl() + "/registration/getForm",
            data: { token: token }
        });
    });

    /*
     * Відкриття форми
     */
    $(document).on('opening', Const.icform_modal, function () {
        $(Const.selector_for_open_form).prop("disabled", true);

    });

    /*
     * Закриття форми
     */
    $(document).on('closed', Const.icform_modal, function () {
        $(Const.icform_modal_form).empty();
        $(Const.selector_for_open_form).prop("disabled", false);

        $(this).remodal().destroy();
    });

    /*
     * Клік по "Застосувати" промокод
     */
    $(document).on('click', Const.selPromocodeBtn, function () {
        var _this = this,
            _form = $(_this).closest('form'),
            _token = _form.find(Const.selEventToken).val(),
            _promocode = _form.find(Const.selPromocode);

        var data = {
                token: _token,
                promocode: _promocode.val()
            };

        App.sendApi({
            url: App.getApiUrl() + "/registration/promocode",
            data: data,
            success: function(response) {
                if('message' in response.data){
                    $(_form).find(Const.selPromocodeInfo).html( response.data.message );
                }

                if('status' in response.data && response.data.status == 'ok'){
                    _promocode.attr('readonly', true);
                    $(_this).prop("disabled", true);
                }
            }
        });
    });

    /*
     * Submit форми реєстрації
     */
    $(document).on('submit', Const.selector_forms, function(e){
        var _this = this;
        e.preventDefault();

        // console.log($$(this));

        if(!$(this).valid()) return false;

        $.loaderShow();

        // try {

            var dataForm = new FormData();

            $.each(Const.fields, function (key, elem) {

                var val = $(_this).find(elem).val();

                if (val) {
                    dataForm.append(key, val);
                }
            });

            App.serializeForm(this, dataForm);
            App.serializeWindowInfo(dataForm);

            // iCube.consoleFormData(dataForm);

            App.sendApi({
                url: App.getApiUrl() + "/registration",
                data: dataForm,
                type: "POST"
            });

            $(_this).clearForm();

        // } catch (e) {
        //     App.logError(e);
        // }

    });

}());
